module.exports = __webpack_public_path__ + "img/ac7757a4e8e81d029745a62318838315.png";